
define('text!Magento_Catalog/template/product/name.html',[],function () { return '<!--\n/**\n * Copyright © Magento, Inc. All rights reserved.\n * See COPYING.txt for license details.\n */\n-->\n<strong if="isAllowed()"\n        class="product-item-name">\n    <a attr="href: $row().url" html="getNameUnsanitizedHtml($col.getLabel($row()))"/>\n</strong>\n';});

